module.exports = __webpack_public_path__ + "static/media/android-2.586d8482.jpg";